<template>
  <div>
    <slot name="header">
      <PlannerHeader id="routine-list-header" @click="handleCreateNewRoutine">routines</PlannerHeader>
    </slot>
  <div>

    <FilterOptions v-model="filter" :filterOptions="filterOptions" class="mb-4"/>

    <div v-if="loading">
      <Loader/>
    </div>

    <div v-else>

      <!-- <transition name="fade" mode="out-in"> -->

        <div v-if="nothingToShow">
            <EmptyState variant="2" title="Make a true change." subtitle="Take one small and consistent action each day and see what a huge impact you can make." subtitle2="What useful and small activity will you perform regularly to be the best you?">

            <div class="mt-4">
              <vs-button class="w-1/2 m-1" @click.stop="handleCreateNewRoutine" >
                create routine
              </vs-button>
              </div>

              <div>
               <vs-button class="w-1/2 m-1 track-routine-get-inspired" type="border" @click.stop="handleGetInspired">
                get inspired
              </vs-button>
            </div>

            </EmptyState>
       <!--      <EmptyState v-else variant="2" title="Nothing to see here." subtitle="You don't have any paused routine"/> -->
        </div>


      <div v-else>
      <!-- <div v-if="urgentRoutines.length > 0"> -->
        <!-- <ListDivider v-if="showDividers" title="today" :count="urgentRoutines.length"/> -->

        <TasksDivider title="must do" :count="urgentRoutines.length" :hideAdd="true"/>
        <div class="mb-10">
          <div v-if="morningRoutines.length > 0">
            <div class="font-semibold mt-1 text-center">morning</div>
            <transition-group name="list">
              <template v-for="routine in morningRoutines">
                <Routine
                  :key="routine.id"
                  :routine="routine"
                  @openSidebar="handleOpenRoutine"
                  class="mb-2"
                  :showSkipToday="true"
                />
              </template>
            </transition-group>
          </div>

          <div v-if="afternoonRoutines.length > 0">
            <div class="font-semibold mt-1 text-center">afternoon</div>
            <transition-group name="list">
              <template v-for="routine in afternoonRoutines">
                <Routine
                  :key="routine.id"
                  :routine="routine"
                  @openSidebar="handleOpenRoutine"
                  class="mb-2"
                  :showSkipToday="true"
                />
              </template>
            </transition-group>
          </div>

          <div v-if="nighttimeRoutines.length > 0">
            <div class="font-semibold mt-1 text-center">nighttime</div>
            <transition-group name="list">
              <template v-for="routine in nighttimeRoutines">
                <Routine
                  :key="routine.id"
                  :routine="routine"
                  @openSidebar="handleOpenRoutine"
                  class="mb-2"
                  :showSkipToday="true"
                />
              </template>
            </transition-group>
          </div>

          <div v-if="anytimeRoutines.length > 0">
            <div v-if="anytimeRoutines.length !== urgentRoutines.length" class="font-semibold mt-1 text-center">anytime</div>
            <transition-group name="list">
              <template v-for="routine in anytimeRoutines">
                <Routine
                  :key="routine.id"
                  :routine="routine"
                  @openSidebar="handleOpenRoutine"
                  class="mb-2"
                  :showSkipToday="true"
                />
              </template>
            </transition-group>
          </div>

        </div>

      <!-- skipped============================================== -->
      <TasksDivider v-if="skippedTodayRoutines.length > 0" title="won't do today" :count="skippedTodayRoutines.length" :hideAdd="true"/>
      <div class="mb-10">
        <transition-group name="list">
          <template v-for="routine in skippedTodayRoutines">
            <Routine
                :key="routine.id"
                :routine="routine"
                @openSidebar="handleOpenRoutine"
                class="mb-2"
                :showSkipToday="true"
              />
          </template>
        </transition-group>
      </div>

      <div v-if="allSection">
        <!-- Should do -->
        <TasksDivider v-if="shouldDoRoutines.length > 0" title="should do" :count="shouldDoRoutines.length" :hideAdd="true" />
        <div class="mb-10">
          <transition-group name="list">
            <template v-for="routine in shouldDoRoutines">
              <Routine
                  :key="routine.id"
                  :routine="routine"
                  @openSidebar="handleOpenRoutine"
                  :showSkipToday="true"
                  class="mb-2"
                />
            </template>
          </transition-group>
        </div>

        <!-- Could do -->
        <TasksDivider v-if="couldDoRoutines.length > 0" title="could do" :count="couldDoRoutines.length" :hideAdd="true"/>
        <div class="mb-10">
          <transition-group name="list">
            <template v-for="routine in couldDoRoutines">
              <Routine
                  :key="routine.id"
                  :routine="routine"
                  @openSidebar="handleOpenRoutine"
                  :showSkipToday="true"
                  class="mb-2"
                />
            </template>
          </transition-group>
        </div>

        <!-- don't have to do ==============-->
        <TasksDivider v-if="dontHaveToDoRoutines.length > 0" title="don't have to do" :count="dontHaveToDoRoutines.length" :hideAdd="true"/>
        <div class="mb-10">
          <transition-group name="list">
            <template v-for="routine in dontHaveToDoRoutines">
              <Routine
                  :key="routine.id"
                  :routine="routine"
                  @openSidebar="handleOpenRoutine"
                  class="mb-2"
                />
            </template>
          </transition-group>
        </div>


        <TasksDivider v-if="pausedRoutines.length > 0" title="paused" :count="pausedRoutines.length" :hideAdd="true"/>
        <div class="mb-10">
          <transition-group name="list">
            <template v-for="routine in pausedRoutines">
              <Routine
                :key="routine.id"
                :routine="routine"
                @openSidebar="handleOpenRoutine"
                class="mb-2"
              />
            </template>
          </transition-group>
        </div>


      </div>


<!--       <div>
        <TasksDivider v-if="showDividers && niceToDoRoutines.length > 0" title="nice to do" :count="niceToDoRoutines.length" />
          <div class="mb-10">
            <transition-group name="list">
              <template v-for="routine in niceToDoRoutines">
                <Routine
                    :key="routine.id"
                    :routine="routine"
                    @openSidebar="handleOpenRoutine"
                    class="mb-2"
                  />
              </template>
            </transition-group>
          </div>
      </div> -->


      </div>
      <!-- </transition> -->

<!--       <div v-if="doneTodayAnything">
        <TasksDivider v-if="showDividers" title="done today" :count="doneTodayRoutines.length"/>
        <div class="mb-10">
          <transition-group name="list">
            <template v-for="routine in doneTodayRoutines">

                <Routine
                  :key="routine.id"
                  :routine="routine"
                  @openSidebar="handleOpenRoutine"
                  class="mb-2"
                />
            </template>
          </transition-group>
        </div>
      </div> -->
    </div>

<!--     <template v-for="routine in routines">
      <Routine
        :key="routine.id"
        :routine="routine"
        @openSidebar="handleOpenRoutine"
        class="mb-2"
      />
  </template> -->
  </div>

    <RoutineSidebar
      :initValue="sidebarActive"
      :editedEntity="editedEntity"
      :showSection="getPrefferedSection"
      @close="sidebarActive=false"
    />


<!--     <Sidebar :initValue="sidebarActive" :title="editedEntity.title || 'create routine'" :saveButton="true" @close="sidebarActive=false">

      <RoutineSidebar :editedEntity="editedEntity" :showSection="prefferedSection" @saved="routineSaved" @close="sidebarActive=false"  />
      <template v-slot:sidebar-footer>
        <vs-button color="dark" @click="$root.$emit('routineSidebarFooterSaveClicked')">save</vs-button>
     </template>
    </Sidebar> -->
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import _ from 'lodash'
import Routine from './Routine'
import RoutineSidebar from './RoutineSidebar'
import PlannerHeader from '../Planner/PlannerHeader'
import FilterOptions from '../Generic/FilterOptions'
import Loader from '../Generic/Loader'
import * as DateHelper from '@/helpers/date'

export default {
  components: {
    draggable,
    Routine,
    RoutineSidebar,
    PlannerHeader,
    FilterOptions,
    Loader,
  },
  props: {
    initWithSidebarOpen: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    getInspiredFilter: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  data () {
    return {
      dragging: false,
      sidebarActive: false,
      editedEntity: {},
      loading: true,
      filter: this.$store.getters.routinesListFilter || 'all',
      filterOptions: ['today', 'all'],
      prefferedSection: null
    }
  },
  computed: {
    getPrefferedSection () {
      if (this.prefferedSection) {
        return this.prefferedSection
      } else if (this.getInspiredFilter) {
        return 'get inspired'
      }
    },
    todaySection () {
      return _.includes(this.filter, 'today')
    },
    allSection () {
      return _.includes(this.filter, 'all')
    },
    // showDividers () {
    //   return _.includes(this.filter, 'active')
    // },
    // doneTodayAnything () {
    //   return this.doneTodayRoutines.length > 0
    // },
    morningRoutines () {
      return _.filter(this.urgentRoutines, (r) => r.schedule === 'morning')
    },
    afternoonRoutines () {
      return _.filter(this.urgentRoutines, (r) => r.schedule === 'afternoon')
    },
    nighttimeRoutines () {
      return _.filter(this.urgentRoutines, (r) => r.schedule === 'nighttime')
    },
    anytimeRoutines () {
      return _.reject(this.urgentRoutines, (r) => r.schedule)
    },
    urgentRoutines () {
      return this.filterRoutines(this.$store.getters.urgentRoutines)
    },
    // doneTodayRoutines () {
    //   return this.$store.getters.doneTodayRoutines
    // },
    // urgentRoutinesAndDone () {
    //   return this.$store.getters.urgentRoutinesAndDone
    // },

    dontHaveToDoRoutines () {
      return this.filterRoutines(this.$store.getters.dontHaveToDoRoutines)
    },

    couldDoRoutines () {
      return this.filterRoutines(this.$store.getters.couldDoRoutines)
    },

    shouldDoRoutines () {
      return this.filterRoutines(this.$store.getters.shouldDoRoutines)
    },

    niceToDoRoutines () {
      return this.filterRoutines(this.$store.getters.niceToDoRoutines)
    },

    skippedTodayRoutines () {
      return this.filterRoutines(this.$store.getters.skippedTodayRoutines)
    },
    pausedRoutines () {
      return this.filterRoutines(this.$store.getters.unfinishedPausedRoutinesEnitities)
    },
    allRoutines () {
      return this.filterRoutines(this.$store.getters.allRoutines)
    },
    nothingToShow () {
      return this.allRoutines.length < 1
    }
  },
  mounted () {
    this.$store.dispatch('bindRoutines').then(() => {
      this.loading = false
    })
  },
  watch: {
    'filter': {
      immediate: false,
      handler (filter) {
        if (filter) {
          this.$store.commit('SET_ROUTINES_LIST_FILTER', { filter: this.filter })
        }
      }
    },
    'initWithSidebarOpen': {
      immediate: true,
      handler (initWithSidebarOpen) {
        if (initWithSidebarOpen) {
          setTimeout(
            () => { this.sidebarActive = true },
            1000
          )
        }
      }
    },
  },
  methods: {
    // filterRoutines (routines) {
    //   return this.sortRoutines(_.filter(routines, (routine) => {
    //     return (_.includes(this.filter, 'active') &&  !routine.paused) ||
    //       (_.includes(this.filter, 'paused') &&  routine.paused)
    //   }))
    // },
    filterRoutines (routines) {
      if (_.get(this.$store.getters.filter, 'color')) {
        return _.filter(routines, (routine) => routine.backgroundColor === this.$store.getters.filter.color)
      } else {
        return routines
      }
    },
    sortRoutines (routines) {
      return _.sortBy(routines, (routine) => {
        if (routine.lastDateDone) {
          return routine.lastDateDone.toDate()
        } else {
          return DateHelper.addDays(routine.startedOn.toDate(), -1)
        }
      })
    },
    handleCreateNewRoutine () {
      this.prefferedSection = null
      this.editedEntity = {}
      this.sidebarActive = true
    },
    handleGetInspired () {
      this.prefferedSection = 'get inspired'
      this.editedEntity = {}
      this.sidebarActive = true
    },
    handleOpenRoutine (routine) {
      this.editedEntity = routine
      this.sidebarActive = true
    },
  },
  // mounted () {
  //   if (this.initWithSidebarOpen) {
  //     this.sidebarActive = true
  //   }
  // }
}

</script>

<style>
</style>
